/**
 * Mobile Navigation Toggle
 * 
 * @package Hersey
 */

(function($) {
	$(document).ready(function() {

		// elements and heights
		var header   = $( 'header[role=banner]' );
		var nav      = $( 'nav', header );
		var adminBar = $( '#wpadminbar' );
		var ulinks   = $( '.user-links' );
		

		/**
		 * Calculate menu offset
		 */
		function getOffset() {

			var headerOffset = header.outerHeight();
			var adminBarOffset = adminBar.length ? adminBar.outerHeight() : 0;

			var offset = headerOffset + adminBarOffset;

			if ( window.innerWidth < 780 ) {
				var unlinksOffset = ulinks.length ? ulinks.outerHeight() : 0;
				offset = offset + unlinksOffset;
			}
			return offset;
		}

		// do offset on init
		var baseOffset = getOffset();
		var navOffset = nav.outerHeight();
		nav.css({ top: -baseOffset + -navOffset });


		/**
		 * Check toggle - see what we need to offset
		 */
		function checkToggle() {

			if ( nav.hasClass( 'toggled' ) ) {
				nav.css({ top: getOffset() });
			} else {
				nav.css({ top: -getOffset() + -nav.outerHeight() });
			}	
		}


		/**
		 * Recalculate menu offset on resize
		 */
		$( window ).resize( checkToggle );


		/**
		 * Add submenu dropdown toggles
		 */
		$( '.menu-item-has-children' ).append(
			'<button class="toggle-sub"><span class="screen-reader-text">Menu</span></button>'
		);


		/**
		 * Toggler: toggle class and position menu
		 */
		$( '#menu-toggle' ).click( function() {

			nav.toggleClass( 'toggled' );
			checkToggle();
		});


		/**
		 * Toggle parent submenu
		 * 
		 * @param current parent's child > a 
		 */
		function toggleParentSubmenu( link ) {

			// get parent
			var li = $(link).parent();

			// show/hide the parent's sub-menu
			li.toggleClass( 'sub-toggled' );
			$( '.sub-menu' , li ).toggle( 300 );
		}


		/**
		 * Toggle submenu if menu item has children and href is #
		 */
		$( '.menu-item-has-children > a' ).on( 'click', function() {

			if ( $(this).attr( 'href' ) == '#' ) {
				toggleParentSubmenu( this );
			}
		});

		
		/**
		 * Open submenu
		 */
		$( '.toggle-sub', '.menu-item-has-children' ).click( function() {
			toggleParentSubmenu( this );
		});

	}); // document.ready
})(jQuery);